

// accordion start product
function product_accordion() {
  this.classList.toggle("product_active");
  var panel = this.nextElementSibling;
  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;
  } else {
    panel.style.maxHeight = panel.scrollHeight + "px";
  } 
}
var accordion = document.getElementsByClassName("product_accordion");
var i;

for (i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", product_accordion);
}
//accordion end product

// footer accordion start
function accordion_add(){
  if($(window).width()<749)
{
  $('.footer-accordion-title').addClass('footer-accordion');
  $('.footer-accordion').next().addClass('footer-accordion-content');
  $('.footer-accordion').click(function(){
  var accr = $(this).text();
  accr = accr.replace(" ", "");
  if($(this).hasClass('ac_active')){
     $(this).removeClass('ac_active');
     $(this).next().removeClass('ac_active');
  }
  else{
    $(this).addClass('ac_active');
    $(this).next().addClass('ac_active');
  }
  $('.footer-accordion').each(function(){
    var acc = $(this).text();
    acc = acc.replace(" ", "");
    if(accr != acc){
      $(this).removeClass('ac_active');
      $(this).next().removeClass('ac_active');
      }
    });
  })
}
else{
  $('.footer-accordion-title').removeClass('footer-accordion').next().removeClass('footer-accordion-content');
  
}

}
$(window).resize(()=>{
  accordion_add()
})
$(document).ready(()=>{
  accordion_add()
})
// footer accordion end